import * as React from 'react';
import { connect } from 'react-redux';
import { SurveyStepMenu } from '../../components/stepper/SurveyStepMenu';
import { IApplicationState } from '../../store';
import { ActionCreators as surveyBuilderActionCreators } from '../../store/SurveyBuilderStore';

export const SurveyStepMenuContainer: React.ComponentType<any> = connect((state: IApplicationState) => state.surveyBuilder, {
	...surveyBuilderActionCreators,
})(SurveyStepMenu);
